/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 3.00012H19M14 3.00012L12 12.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 21.0001H15M12.4444 10.0001L10 21.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M9 3H19M5 21H15M14 3L10 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M9 3H19M5 21H15M14 3L10 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 3.00012H14M14 3.00012L12.5 9.75012M14 3.00012H19M10 21.0001H15M10 21.0001H5M10 21.0001L11.5 14.2501"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8.99976 3.00012H18.9998M4.99976 21.0001H14.9998M13.9998 3.00012L9.99976 21.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M9 3H19M5 21H15M14 3L10 21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
